var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "create_30px_white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,0 C23.2842712,0 30,6.71572875 30,15 C30,23.2842712 23.2842712,30 15,30 C6.71572875,30 0,23.2842712 0,15 C0,6.71572875 6.71572875,0 15,0 Z M15,2 C7.82029825,2 2,7.82029825 2,15 C2,22.1797017 7.82029825,28 15,28 C22.1797017,28 28,22.1797017 28,15 C28,7.82029825 22.1797017,2 15,2 Z M15,7.5 C15.4704756,7.5 15.8617691,7.83901848 15.9429149,8.2860897 L15.9583553,8.45835527 L15.9583553,14.0399912 L21.5416447,14.0416447 C22.0121203,14.0416447 22.4034138,14.3806632 22.4845596,14.8277344 L22.5,15 C22.5,15.4704756 22.1609815,15.8617691 21.7139103,15.9429149 L21.5416447,15.9583553 L15.9583553,15.9567018 L15.9583553,21.5416447 C15.9583553,22.0121203 15.6193368,22.4034138 15.1722656,22.4845596 L15,22.5 C14.5295244,22.5 14.1382309,22.1609815 14.0570851,21.7139103 L14.0416447,21.5416447 L14.0416447,15.9567018 L8.45835527,15.9583553 C7.98787971,15.9583553 7.59658617,15.6193368 7.51544039,15.1722656 L7.5,15 C7.5,14.5295244 7.83901848,14.1382309 8.2860897,14.0570851 L8.45835527,14.0416447 L14.0416447,14.0399912 L14.0416447,8.45835527 C14.0416447,7.98787971 14.3806632,7.59658617 14.8277344,7.51544039 L15,7.5 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.1c20dcd79b3d98d81ddc3da67b127125.svg";
export { ForwardRef as ReactComponent };